import * as localApi from '../../../api/fuel_request/local'
import * as field from '../field'

export const operatorFuelRequestHistoryLocalAction = () => async (dispatch, getState) => {
    let currentState = getState()
    let vOperatorMobileNumber = currentState.config.mobile
    let result = await localApi.operatorFuelRequestHistoryLocal({ vOperatorMobileNumber, vType: 'new' })
    if (result.status) dispatch(field.setFields([
        { data: result.data[0].list, field: 'list' },
        { data: result.data[0].details, field: 'details' }
    ]))
}